module.exports = __webpack_public_path__ + "img/check-off.eb05293b.png";